// extracted by mini-css-extract-plugin
export default {"root":"_3FRtghnH","hasVideo":"_3Aj67paT","square":"_2YR5Euqa","vertical":"_1xfKGWnN","yes":"_1ugyYonT","player":"IpnyRsKe"};